import { Box, Button, FormHelperText, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import React from 'react';
import TermsDialog from '../Dialog/TermsDialog';
import RenderForm from './RenderForm';
import { IMetadataJSON } from './Selector/types';

interface FinalFormProps {
  form_stacture: IMetadataJSON[]
  form_checkBoxes: {
    acceptPolicy?: boolean;
    truthOnDetails?: boolean;
  }
  onSubmit: any;
}

function FinalForm(props: FinalFormProps) {
  const { form_stacture = [], form_checkBoxes = [] as any, onSubmit } = props;
  const [formValues, setFormValues] = React.useState<any>([]);
  const [termsOpen, setTermsOpen] = React.useState<boolean>(false);
  const [checked, setChecked] = React.useState(false);

  const handleClickOpen = () => {
    setTermsOpen(true);
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const requiredFieldsAreFilled = formValues.length > 0 ?
    formValues.map((field: any) => {
      const { fieldIsRequired, propertyValue } = field || {};
      return fieldIsRequired
        ? Array.isArray(propertyValue)
          ? !!propertyValue.length
          : !!propertyValue
        : true;
    }).every((field: any) => field)
    : false;


  const isSubmitEnabled = checked && requiredFieldsAreFilled;
  return (<>

    <FormHelperText>
      <Typography
        variant='body2'
        textAlign='start'
        fontStyle='italic'
        sx={{
          mb: 6,
          color: 'black',
          fontWeight: 'bolder',
        }}
      >
        Συμπληρώστε τα παρακάτω πεδία. Τα πεδία με * είναι υποχρεωτικά,
        οπότε παρακαλούμε βεβαιωθείτε ότι τα έχετε συμπληρώσει.
      </Typography>
    </FormHelperText>
    <RenderForm setMetadataArray={setFormValues} metadataArray={form_stacture} />
    <Box mt={2}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={handleCheckboxChange} />
        }
        label={
          <>
            <Button onClick={handleClickOpen}>Αποδοχή όρων Χρήσης & Ορθότητας Στοιχείων</Button>
            <TermsDialog open={termsOpen} handleClose={() => setTermsOpen(false)}
              onAccept={() => {
                setTermsOpen(false);
                setChecked(true);
              }}
              onDecline={() => setChecked(false)} />
          </>
        } />
    </Box>

    <Box display='flex' justifyContent='flex-end'>
      <Button disabled={!isSubmitEnabled} onClick={() => onSubmit(formValues)}
        variant='contained'>Υποβολή Αίτησης</Button>
    </Box>

  </>);
}

export default FinalForm;